module.exports = __webpack_public_path__ + "img/discount.b71ae7fe.svg";